import {SidebarDeployments as DeploymentsComponent} from '@github-ui/code-view-sidebar/components/SidebarDeployments'
import type {SidebarDeploymentsResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
  /** Environment names from the about payload — passed to skip re-querying them on the backend. */
  environmentNames: string[]
}

export function SidebarDeployments({ownerLogin, repoName, environmentNames}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'deployments', {ownerLogin, repoName, environmentNames}],
    queryFn: async () => {
      const params = new URLSearchParams()
      for (const name of environmentNames) {
        params.append('environments[]', name)
      }
      const queryString = params.toString()
      const url =
        queryString.length > 0
          ? `/${ownerLogin}/${repoName}/_sidebar/deployments?${queryString}`
          : `/${ownerLogin}/${repoName}/_sidebar/deployments`
      const r = await verifiedFetchJSON(url)
      if (!r.ok) throw new Error(`Sidebar deployments fetch failed (${r.status})`)
      return (await r.json()) as SidebarDeploymentsResponse
    },
  })

  if (!data) return null
  return <DeploymentsComponent {...data} />
}
